export default __webpack_public_path__ + "static/media/room-6.3697aea3.jpg";